"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Blog = _interopRequireDefault(require("settings-ui-sdk/Blogs/Blog"));

var _getLastNumericTokenInURL = _interopRequireDefault(require("settings-ui-sdk/utils/getLastNumericTokenInURL"));

var _default = function _default(payload) {
  if (payload.data.objects.length < 1) {
    return new _Blog.default({});
  }

  var blogId = (0, _getLastNumericTokenInURL.default)(window.location.href);
  var blogData = payload.data.objects.find(function (obj) {
    return obj.id === blogId;
  }) || payload.data.objects[0];
  return new _Blog.default(blogData);
};

exports.default = _default;
module.exports = exports.default;